import { BASE_URL } from '../services/apiClient';

export const getImageUrl = (url) => {
    if (!url) return '';
    if (url.startsWith('http://') || url.startsWith('https://')) {
        return url;
    }
    if (url.startsWith('/assets/') || url.startsWith('assets/')) {
        return url.startsWith('/') ? url : `/${url}`;
    }
    const cleanUrl = url.startsWith('/') ? url : `/${url}`;
    return `${BASE_URL}${cleanUrl}`;
};
